'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _FolderOutlined = _interopRequireDefault(require('./lib/icons/FolderOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _FolderOutlined;
exports.default = _default;
module.exports = _default;